// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.


const CarouselSlider = ((($) => {
  let slider;
  function init() {
    slider = $('.Gallery-texts-list');

    slider.slick({
      dots: false,
      fade: true,
      infinite: true,
      speed: 1000,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: $('.slider_next-is'),
      prevArrow: $('.slider_prev-is'),
      asNavFor: '.Gallery-images-list'
    });

    $('.Gallery-images-list').slick({
      dots: false,
      infinite: true,
      speed: 1000,
      centerPadding: '150px',
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: $('.slider_next-fw'),
      prevArrow: $('.slider_prev-fw'),
      asNavFor: '.Gallery-texts-list',
      centerMode: true,
      focusOnSelect: true,
      responsive:[
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
          }
        }
      ]
    });

    $('.slider-ctrl').width($('.Gallery-image img').width());

    $(window).on('resize', function() {
      $(this);
      $('.slider-ctrl').width($('.Gallery-image img').width());
    });
  }
  return {
    init,
  };
}))(jQuery);

export default CarouselSlider;



// WEBPACK FOOTER //
// ./src/static/js/modules/carousel-slider.js